import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';


import { AutoComplete, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';

// Composants
import { BaseComponent } from '../abstract/base.component';

// Modèles
import { Organization } from '../../models/legal-entity/organization.model';

// Utils
import { Filter } from '../../utilities/models/filter';
import { Logger } from 'src/app/@core/services/logger/logger.service';
import { Country } from '../../models/core/country.model';
import { Sorter } from '../../utilities/models/sorter';

const LOGGER = new Logger('OrganizationSearchFormComponent');

@Component({
    selector: 'app-organization-search-form',
    imports: [
    AutoCompleteModule
],
    templateUrl: './organization-search-form.component.html',
    styleUrls: ['./organization-search-form.component.scss']
})
export class OrganizationSearchFormComponent extends BaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Input()
    country!: Country;

    @Output() organizationSelected = new EventEmitter();

    @ViewChild('autocomplete') autocomplete!: AutoComplete;

    private _backgroundClass: string = '';
    public get backgroundClass(): string {
        return this._backgroundClass;
    }
    @Input()
    public set backgroundClass(value: string) {
        this._backgroundClass = value ?? '';
    }

    public get inputStyleClass(): string {
        return `py-4 pl-7 ${this._backgroundClass}`.trim();
    }

    public get placeholder(): string {
        switch (this.country.alpha2) {
            case 'FR':
                return 'Rechercher par SIRET/SIREN, nom ou raison sociale';
            case 'PF':
                return 'Rechercher par n° TAHITI, nom ou raison sociale';
            default:
                return 'Rechercher par RID/RIDET, nom ou raison sociale';
        }
    }

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _organizations: Organization[] = [];
    public get organizations(): Organization[] {
        return this._organizations;
    }
    public set organizations(organizations: Organization[]) {
        let emptyArray: Organization[] = [];
        this._organizations = emptyArray.concat(organizations);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public onSearch(event: any) {
        this._search(event.query);
    }

    public onSelectOrganization(event: AutoCompleteSelectEvent) {
        this._selectOrganization(event.value);
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    private _search(query: string) {

        let filterCountry = new Filter({
            property: 'country',
            comparator: Filter.COMPARATOR.EQ,
            value: this.country.alpha2
        });
        let filterQuery = new Filter({
            filters: [
                new Filter({
                    property: 'query',
                    comparator: Filter.COMPARATOR.EQ,
                    value: query
                }),
            ],
            and: false
        });

        let sorter: Sorter = new Sorter({
            property: 'name',
        });

        // Recherche dans la base du pays
        this.organizationService.getList$({
            filters: [filterCountry, filterQuery],
            sorters: [sorter],
        }).subscribe(organizations => this.organizations = organizations);
    }

    private _selectOrganization(organization: Organization) {
        this.organizationSelected.emit(organization);
    }

}
